import React from "react"
import { createUseDisableImportedStyles } from '../useDisableImportedStyles'

import './silent-dot.scss'

const useDisableImportedStyles = createUseDisableImportedStyles(true)

const Theme = () => {
    useDisableImportedStyles()
    return (<></>)
}

export default Theme